
export default function AnchorRequirementsSection() {
  const requirements = [
    {
      title: '基础门槛',
      items: [
        { label: '粉丝数量', value: '1万+', icon: 'ri-user-line' },
        { label: '直播经验', value: '3个月+', icon: 'ri-time-line' },
        { label: '平均观看', value: '500+', icon: 'ri-eye-line' },
        { label: '带货经验', value: '有经验优先', icon: 'ri-shopping-bag-line' }
      ]
    },
    {
      title: '平台要求',
      items: [
        { label: '抖音直播', value: '主要平台', icon: 'ri-tiktok-line' },
        { label: '快手直播', value: '支持平台', icon: 'ri-live-line' },
        { label: '淘宝直播', value: '支持平台', icon: 'ri-taobao-line' },
        { label: '小红书', value: '新兴平台', icon: 'ri-book-line' }
      ]
    },
    {
      title: '专业要求',
      items: [
        { label: '表达能力', value: '口齿清晰', icon: 'ri-mic-line' },
        { label: '学习能力', value: '快速学习', icon: 'ri-book-open-line' },
        { label: '服务意识', value: '客户至上', icon: 'ri-heart-line' },
        { label: '时间管理', value: '按时直播', icon: 'ri-calendar-line' }
      ]
    }
  ];

  const tiers = [
    {
      name: '新星主播',
      level: '入门级',
      requirements: ['粉丝1-5万', '直播经验3个月+', '愿意学习茶叶知识'],
      commission: '15-20%',
      support: ['基础培训', '产品提供', '客服支持'],
      color: 'from-blue-500 to-blue-600',
      icon: 'ri-seedling-line'
    },
    {
      name: '优质主播',
      level: '进阶级',
      requirements: ['粉丝5-20万', '直播经验6个月+', '有带货经验'],
      commission: '20-25%',
      support: ['专业培训', '优质产品', '营销支持', '流量扶持'],
      color: 'from-blue-500 to-blue-600',
      icon: 'ri-star-line'
    },
    {
      name: '头部主播',
      level: '专家级',
      requirements: ['粉丝20万+', '直播经验1年+', '专业带货能力'],
      commission: '25-30%',
      support: ['定制服务', '独家产品', '专属客服', '分红计划'],
      color: 'from-blue-500 to-blue-600',
      icon: 'ri-vip-crown-line'
    }
  ];

  return (
    <section id="requirements" className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            合作要求
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            我们欢迎不同层级的主播加入，提供差异化的合作方案
          </p>
        </div>

        {/* Basic Requirements */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {requirements.map((category, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-6 text-center">
                {category.title}
              </h3>
              <div className="space-y-4">
                {category.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="flex items-center justify-between p-3 bg-white rounded-lg">
                    <div className="flex items-center">
                      <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                        <i className={`${item.icon} text-blue-600`}></i>
                      </div>
                      <span className="text-sm md:text-base text-gray-700 font-medium">{item.label}</span>
                    </div>
                    <span className="text-xs md:text-sm text-blue-600 font-semibold">{item.value}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Tier System */}
        <div className="mb-12">
          <h3 className="text-xl md:text-2xl font-bold text-center text-gray-800 mb-8">主播等级体系</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {tiers.map((tier, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group hover:transform hover:scale-105"
              >
                <div className={`h-2 bg-gradient-to-r ${tier.color}`}></div>
                <div className="p-6">
                  <div className="text-center mb-6">
                    <div className={`w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-r ${tier.color} flex items-center justify-center`}>
                      <i className={`${tier.icon} text-white text-2xl`}></i>
                    </div>
                    <h4 className="text-lg md:text-xl font-bold text-gray-800 mb-1">{tier.name}</h4>
                    <p className="text-sm md:text-base text-gray-500">{tier.level}</p>
                  </div>
                  
                  <div className="space-y-4">
                    <div>
                      <h5 className="text-sm md:text-base font-semibold text-gray-800 mb-2">申请条件</h5>
                      <div className="space-y-1">
                        {tier.requirements.map((req, reqIndex) => (
                          <div key={reqIndex} className="flex items-center text-xs md:text-sm text-gray-600">
                            <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></div>
                            {req}
                          </div>
                        ))}
                      </div>
                    </div>
                    
                    <div>
                      <h5 className="text-sm md:text-base font-semibold text-gray-800 mb-2">佣金比例</h5>
                      <div className={`text-base md:text-lg font-bold bg-gradient-to-r ${tier.color} bg-clip-text text-transparent`}>
                        {tier.commission}
                      </div>
                    </div>
                    
                    <div>
                      <h5 className="text-sm md:text-base font-semibold text-gray-800 mb-2">专属支持</h5>
                      <div className="space-y-1">
                        {tier.support.map((support, supportIndex) => (
                          <div key={supportIndex} className="flex items-center text-xs md:text-sm text-gray-600">
                            <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></div>
                            {support}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ */}
        <div className="bg-gray-50 rounded-2xl p-8">
          <h3 className="text-xl md:text-2xl font-bold text-center text-gray-800 mb-8">常见问题</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              {
                question: '如何计算佣金？',
                answer: '佣金按照实际销售额计算，结算周期为月结，每月5号结算上月佣金。'
              },
              {
                question: '需要囤货吗？',
                answer: '无需囤货，我们提供一件代发服务，订单直接从仓库发货给客户。'
              },
              {
                question: '有培训支持吗？',
                answer: '有完整的培训体系，包括产品知识、销售技巧、直播话术等。'
              },
              {
                question: '售后问题如何处理？',
                answer: '我们有专业的售后团队处理客户问题，主播无需担心售后事宜。'
              }
            ].map((faq, index) => (
              <div key={index} className="bg-white rounded-lg p-4">
                <h4 className="text-sm md:text-base font-semibold text-gray-800 mb-2">{faq.question}</h4>
                <p className="text-xs md:text-sm text-gray-600">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
